import http from "@/http-common";

/* eslint-disable */
class SignUpUserInfoDataService {
  // Common urls start
  getPermissionDetail(data = {}): Promise<any> {
    return http.api.post("/signup_getPermissionDetail/", data);
  }
  
  getChkApp(data: any): Promise<any> {
    return http.api.post("/signup_chkApp/", data);
  }

  send_authenticationID(data: any): Promise<any> {
    return http.api.post("/signup_send_authenticationID/", data);
  }
  // Common urls end

  insertUserInfo(data: any): Promise<any> {
    return http.api.post("/signup_insertUserInfo/", data);
  }

  chkApplicationUserID(data: any): Promise<any> {
    return http.api.post("/signup_chkApplicationUserID/", data);
  }

  insertTmpUserInfo(data: any): Promise<any> {
    return http.api.post("/signup_insertTmpUserInfo/", data);
  }

  getStationData(data : any): Promise<any>{
    return http.api.post("/signup_getStationData/", data);
  }

  getEmployeeIDData(data : any): Promise<any>{
    return http.api.post("/signup_getEmployeeIDData/", data);
  }

  getTmpEmployeeIDData(data : any): Promise<any>{
    return http.api.post("/signup_getTmpEmployeeIDData/", data);
  }
  
  getDepartmentInfo(): Promise<any> {
    return http.api.post("/signup_getDepartmentInfo/");
  }

  getMenuStationMapping(data : any): Promise<any>{
    return http.api.post("/signup_getMenuStationMapping/", data);
  }
}

export default new SignUpUserInfoDataService();
